// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__2QPC8","ribbons":"ribbons__3tceb","ribbon":"ribbon__3Hput"};


//////////////////
// WEBPACK FOOTER
// ./components/ribbons/style.styl
// module id = BatL
// module chunks = 0